import _asyncToGenerator from "@babel/runtime/helpers/esm/asyncToGenerator";
import "regenerator-runtime/runtime.js";
import "core-js/modules/es.array.find.js";
import "core-js/modules/es.array.join.js";
import "core-js/modules/es.array.map.js";
import "core-js/modules/es.object.to-string.js";
import "core-js/modules/web.dom-collections.for-each.js";
import axios from 'axios';

// Create cache validation timestamp just once
// and use that for all requests
var cv = Math.floor(Date.now() / 1000);
export default (function (_ref, inject) {
  var $config = _ref.$config;
  var token = $config.STORYBLOK_TOKEN;
  var configsByCountry = {};
  inject('storyblok', {
    getAppConfig: function getAppConfig(country) {
      return _asyncToGenerator(/*#__PURE__*/regeneratorRuntime.mark(function _callee() {
        var relations, _t;
        return regeneratorRuntime.wrap(function (_context) {
          while (1) switch (_context.prev = _context.next) {
            case 0:
              relations = ['activation_nagger_logos', 'subscribe_modal_quotes', 'subscribe_modal_logo_cloud'];
              if (configsByCountry[country]) {
                _context.next = 4;
                break;
              }
              _context.prev = 1;
              _context.next = 2;
              return axios.get("https://api.storyblok.com/v2/cdn/stories/data/app-config-".concat(country.toLowerCase()), {
                params: {
                  token: token,
                  cv: cv,
                  resolve_relations: relations.join(',')
                }
              }).then(function (r) {
                return resolveRelations(r.data, relations).story;
              });
            case 2:
              configsByCountry[country] = _context.sent;
              _context.next = 4;
              break;
            case 3:
              _context.prev = 3;
              _t = _context["catch"](1);
              // eslint-disable-next-line no-console
              console.error(_t);
              return _context.abrupt("return", null);
            case 4:
              return _context.abrupt("return", configsByCountry[country]);
            case 5:
            case "end":
              return _context.stop();
          }
        }, _callee, null, [[1, 3]]);
      }))();
    }
  });
});
function resolveRelations(config, relations) {
  relations.forEach(function (relation) {
    var target = config.story.content[relation];
    if (Array.isArray(target)) {
      config.story.content[relation] = target.map(function (uuid) {
        return config.rels.find(function (rel) {
          return rel.uuid === uuid;
        }) || uuid;
      });
    }
  });
  return config;
}